import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificadorService {

  private rutServicioNotificador = AppSettings.urlNotificador;

  constructor( private httClient: HttpClient ) {
  }

  obtenerSolicitud( idSolicitud: string ) {
    return this.httClient.get( this.rutServicioNotificador + '/obtenerSolicitud/' + idSolicitud ).pipe( map( res => res as any ) );
  }

}
